<template>
  <div class="bookcard">
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <img :src="cover_src" style="clip: rect(0px,128px,128px,0px);" />
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <router-link to="/reader">
            <strong class="has-text-dark">{{book_name }}</strong>
          </router-link>
          <p>{{preview}}</p>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import BasicAPIs from "@/api/apis";
export default {
  name: "BookCard",
  props: {
    book_id: String
  },
  data() {
    return {
      book_name: "Loading...",
      preview: "Loading...",
      cover_src: "https://bulma.io/images/placeholders/128x128.png"
    };
  },
  mounted() {
    let vm = this;
    BasicAPIs.getBooksummary(vm.book_id).then(res => {
      let book = res.data.msg.book;
      vm.book_name = book.title;
      vm.preview = book.abstract;
      vm.cover_src = book.cover_src;
      return true;
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variable.scss";
.bookcard {
  background-color: $headfoot-bg;
  color: black;
  margin: 0.5em auto;
  padding: auto 0.5em;
}
.content {
  margin: 0.2em;
}
</style>
